import {TKey} from '@/translations/i18n'

const STATUS_LABEL_KEY: Record<string, TKey> = {
    pending: 'exports:status_pending',
    processing: 'exports:status_processing',
    ready: 'exports:status_ready',
    failed: 'exports:status_failed',
    archived: 'exports:status_archived',
    cancelled: 'exports:status_cancelled',
    expired: 'exports:status_expired'
}

/** i18n key for a status, or undefined for an unknown status (caller shows the raw value). */
export const statusLabelKey = (status: string): TKey | undefined => STATUS_LABEL_KEY[status]
